import { AlertColor } from '@mui/material'
import { createContext } from 'react'

type UiContextInterface = {
  showSnackbar: (message: string, severity?: AlertColor) => void
  showHelpDrawer: (title: string, message: React.ReactNode, buttonLabel?: string) => void
}

export const UiContext = createContext<UiContextInterface>({
  showSnackbar: () => {
    return null
  },
  showHelpDrawer: () => {
    return null
  },
})
